import { useEffect, useRef, useState } from 'react';

import { IconTimesDefault } from '@iwoca/icons';

export const MobileDrawerShell = ({
    children,
    ...rest
}: {
    children: (props: {
        isOpen: boolean;
        toggle: () => void;
    }) => React.ReactNode;
} & Omit<React.ComponentPropsWithoutRef<'div'>, 'children'>) => {
    const [isOpen, setIsOpen] = useState(false);
    const startY = useRef(0);
    const panelRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isOpen) return;
        const handleClickOutside = (e: MouseEvent | TouchEvent) => {
            const target = e.target as HTMLElement;
            if (
                panelRef.current &&
                !panelRef.current.contains(target) &&
                !target.closest('[role="dialog"]')
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener('pointerdown', handleClickOutside);
        return () =>
            document.removeEventListener('pointerdown', handleClickOutside);
    }, [isOpen]);

    return (
        <>
            <div
                ref={panelRef}
                className="fixed bottom-0 left-0 right-0 z-10 touch-none rounded-tl-l rounded-tr-l bg-primary-10 p-xl text-structure-100"
                {...rest}
                onPointerDown={(e) => {
                    startY.current = e.clientY;
                }}
                onPointerUp={(e) => {
                    const delta = startY.current - e.clientY;
                    if (delta > 30) setIsOpen(true);
                    if (delta < -30) setIsOpen(false);
                }}
            >
                {isOpen && (
                    <button
                        className="absolute right-m top-m"
                        onClick={() => setIsOpen(false)}
                        data-testid="close-mobile-summary"
                    >
                        <IconTimesDefault fontSize="24px" />
                    </button>
                )}

                {children({ isOpen, toggle: () => setIsOpen((v) => !v) })}
            </div>

            {/* Spacer so content behind the fixed drawer isn't hidden */}
            <div className="h-[160px]" />
        </>
    );
};
